import { DB } from '@/extensions/db'

let instance = null

export class Global {
  constructor () {
    this._table = DB.global

    instance = instance || this

    return instance
  }

  async get () {
    return this._table.get(1)
  }

  async update (data) {
    return this._table.update(1, data)
  }
}



// WEBPACK FOOTER //
// ./src/models/global.js